import {
  Modal,
  UPDATE_CURRENT_COMPANY,
} from '@employ-engage/common-components';
import { NextLevelKey } from '@employ-engage/data';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';

export interface DeleteOrgLevelModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  nextLevelKeys: NextLevelKey[];
  refetchCompany: () => void;
}

export function DeleteOrgLevelModal({
  open,
  setOpen,
  nextLevelKeys,
  refetchCompany,
}: DeleteOrgLevelModalProps) {
  const [updateCompany] = useMutation(UPDATE_CURRENT_COMPANY);
  const { t } = useTranslation(['common']);
  const deleteOrgLevel = () => {
    updateCompany({
      variables: {
        input: {
          orgTreeNextLevelKeys: nextLevelKeys.slice(0, -1).map((key) => ({
            id: key.id,
            name: key.name,
            color: key.color,
          })),
        },
      },
    })
      .then(() => {
        console.info('Document successfully updated!');
        refetchCompany();
      })
      .catch((error) => {
        console.error('Error updating document: ', error);
      });
    setOpen(false);
  };

  return (
    <Modal open={open} setOpen={setOpen}>
      <div>
        <h1 className="mb-3 text-lg font-bold">Delete Organization Level</h1>
        <p className="text-red-500">
          Are you sure you want to delete{' '}
          <span className="font-bold">
            {nextLevelKeys[nextLevelKeys.length - 1]?.name}
          </span>
          ? This will delete the suborganization that corresponds to this level.
          This action cannot be undone.
        </p>
        <div className="mt-4">
          <button className="mr-4" onClick={() => setOpen(false)}>
            {t('Cancel')}
          </button>
          <button onClick={deleteOrgLevel}>{t('Delete')}</button>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteOrgLevelModal;
